(() => {
  const QUERY = '(max-width: 749px)';
  const HEADER_SELECTOR = '.pdp_header__block';
  const SLOT_SELECTOR = '.thr-pdp-mobile-header';
  const HOME_SELECTOR = '.thr-pdp-header-home';

  const media = window.matchMedia(QUERY);

  const getPdp = () => document.querySelector('.thr-pdp.product-information');

  const ensureHome = (pdp, header) => {
    const existing = pdp.querySelector(HOME_SELECTOR);
    if (existing) return existing;
    if (header.parentElement?.classList.contains('thr-pdp-mobile-header')) return null;
    const home = document.createElement('span');
    home.className = 'thr-pdp-header-home';
    home.hidden = true;
    header.parentElement?.insertBefore(home, header);
    return home;
  };

  const place = () => {
    const pdp = getPdp();
    if (!pdp) return;
    const slot = pdp.querySelector(SLOT_SELECTOR);
    const header = pdp.querySelector(HEADER_SELECTOR);
    if (!slot || !header) return;

    const home = ensureHome(pdp, header);
    if (media.matches) {
      if (header.parentElement !== slot) slot.appendChild(header);
      return;
    }
    if (home?.parentElement) {
      home.parentElement.insertBefore(header, home.nextSibling);
    }
  };

  media.addEventListener('change', place);
  document.addEventListener('shopify:section:load', place);
  document.addEventListener('shopify:section:reorder', place);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
})();
